import React, { useContext, useEffect, useState } from 'react';
import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Dialog, makeStyles } from '@material-ui/core';
import { Theme } from 'src/theme';
import NavLeft from './NavLeft';
import NavRight from './NavRight';
import TopBar from '../Topbar';
import { RootState } from 'src/store';
import { editCurrentButton } from 'src/store/modules/trackings';
import GuestHeader from 'src/views/workspace/components/layouts/GuestHeader';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import { useHistory, useLocation } from 'react-router';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    minWidth: 1200,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // overflow: 'hidden',
    backgroundColor: '#e5e5e5'
  },
  container: {
    height: 'calc(100vh - 3rem)',
    // marginTop: '3rem',
    display: 'flex',
    flexDirection: 'row',
    minWidth: 1200
  },
  templateWrapper: {
    width: '100%',
    minWidth: '35rem',
    height: 'calc(100vh - 3rem)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // flex: '1 1 auto'
    overflowX: 'scroll',
    overflowY: 'hidden'
  },
  guide: {
    position: 'absolute',
    width: 47,
    height: 47,
    bottom: '2vw',
    right: '2vw',
    zIndex: 10000
  },

  sideWrapper: {
    width: '20rem',
    minWidth: '20rem',
    display: 'flex'
  },
  buttonWrapper: {
    width: '2.5rem',
    height: '7.5rem',
    lineHeight: '120%',
    // marginTop: '3rem',

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    // position: 'absolute',
    // left: '13.25rem',

    color: '#fff',
    fontFamily: 'Archivo',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 700,

    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    borderRadius: '0 1rem 1rem 0',
    backgroundColor: '#646464'
  },

  bottomWrapper: {
    width: 'calc(100% - 33.25rem)',
    minWidth: '41.75rem',
    position: 'absolute',
    bottom: 0,
    left: '13.25rem',
    backgroundColor: '#fff'
  }
}));

const DashboardLayout: FC<DashboardLayoutProps> = ({ children }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  // const location = useLocation();
  const history = useHistory();
  var currentButton = useSelector(
    (state: RootState) => state.trackings.currentButton
  );
  const [guestMode, setGuestMode] = useState(false);
  const { authStatus } = useContext(AuthContext);
  const onClickLogoGuest = () => {
    history.push('/workspace/templates');
  };
  useEffect(() => {
    if (authStatus !== AuthStatus.SignedIn) {
      setGuestMode(true);
    } else {
      setGuestMode(false);
    }
  }, [authStatus]);

  return (
    <>
      {guestMode && (
        <div style={{ padding: '0 15px', background: 'black' }}>
          <GuestHeader
            onClickLogoGuest={onClickLogoGuest}
            style={{
              background: 'black',
              color: 'white',
              border: 'white',
              buttonColor: 'white',
              buttonBackground: '#333333'
            }}
          />
        </div>
      )}
      <div className={classes.root}>
        <TopBar />
        <div className={classes.container}>
          <Box className={classes.sideWrapper}>
            <NavLeft />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {[...Array(2)].map((_: any, idx: number) => {
                return (
                  <Box
                    key={idx}
                    className={classes.buttonWrapper}
                    style={{
                      top: `calc(7.5 * ${idx}rem)`,
                      backgroundColor:
                        currentButton === idx ? '#434343' : '#646464'
                    }}
                    onClick={() => {
                      dispatch(editCurrentButton(idx));
                    }}
                  >
                    BUTTON{idx + 1}
                  </Box>
                );
              })}
            </div>
          </Box>
          <Box className={classes.templateWrapper}>{children}</Box>
          <Box className={classes.sideWrapper}>
            <NavRight />
          </Box>
        </div>
      </div>
    </>
  );
};

// DashboardLayout.propTypes = {
//   children: PropTypes.node
// };

export default DashboardLayout;
